import { useEffect, useState } from 'react';
import { Flex } from '@/app/ui/atoms';
import { CustomBarChart } from '@/app/ui';
import Colors from '@/app/styles/Colors';
import { BarData } from '@/app/ui/organisms/CustomBarChart/CustomBarChart';

const AnualEarning = () => {
  const [earningData, setEarningData] = useState<BarData[][]>([]);

  useEffect(() => {
    const years = ['2022', '2023', '2024'];

    const earningsDistBarData: BarData[] = years.map((year) => ({
      x: year,
      y: 7 + parseInt(year[3], 10),
    }));

    const earningsPubBarData: BarData[] = years.map((year) => ({
      x: year,
      y: 4 + parseInt(year[3], 10),
    }));

    setEarningData([earningsDistBarData, earningsPubBarData]);
  }, []);

  return (
    <Flex.Container flexDirection="column" className="mt-1" gap="2.5rem">
      <CustomBarChart
        yaxis="Royalties"
        data={earningData}
        barColors={[Colors.primary, Colors.pink]}
        legend={['Distribution', 'Publishing']}
      />
    </Flex.Container>
  );
};

export default AnualEarning;
